export const over_view_option_fun = () => ({
    /* title */
    title: {
        text: '',
        textStyle: {
            color:'#808080',
            fontSize: 20,
        },
        top: 10,
        left: 'center',
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            label: {
                backgroundColor: '#6a7985'
            }
        }
    },
    color: ['#5AC4A0', '#7FBDF2'],
    legend: {
        show:true,
        // 位置
        bottom: '2%',
        // 样式
        icon: 'rect',
        textStyle: {
            fontSize:16,
            lineHeight:20,
            fontWeight: 'bold'
        }
        // 数据
        // data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
    },
    grid: {
        show: false, // 不显示网格
        containLabel: true,
        top: 100,
        left: '3%',
        right: '3%',
        bottom: '10%',
        borderWidth: 0, 
    },
    xAxis: [
        {
            show: true,
            type: 'category',
            boundaryGap: false,
            // data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            splitLine: {
              show: false
            }
        }
    ],
    yAxis: [
        {
            type: 'value',
            show:true,
            axisLine: {
                show:false
            },
            axisLabel: {
                show: true,
                margin: 20,
            },
            minorSplitLine: {
                show: false
            },
            name: '',
            nameTextStyle: {
                color: '#969696',
                padding: [0, 0, 0, 20]  
            }
        }
    ],
    series: []
})


export const BUTTON_FIELDS = [
    {
        title:'现金收入',
        key: 'income',
        // price: 10000000000
    },
    {
        title:'用户数',
        // price: 1000,
        key: 'user'
    },
    {
        title:'新用户数',
        // price: 1000,
        key: 'new_user'
    },
    {
        title:'老用户数',
        // price: 1000,
        key: 'old_user'
    },
    {
        title:'客单价',
        // price: 1000,
        key: 'unit_price'
    }
]
const item = {
    total: undefined,
    isRais: undefined,
    percent: undefined,
    num: undefined
}
export const default_hash_data = {
    income: item,
    user: item,
    old_user: item,
    new_user: item,
    unit_price: item
}

export const daily_title_hash = {
    0:'每日现金收入趋势环比上月',
    1:'每日付费用户趋势环比上月',
    2:'每日付费新用户趋势环比上月',
    3:'每日付费老用户趋势环比上月',
    4:'每日客单价趋势环比上月'
}

export const acc_title_hash = {
    0:'现金累计收入趋势环比上月',
    1:'付费用户累计趋势环比上月',
    2:'付费新用户累计趋势环比上月',
    3:'付费老用户累计趋势环比上月',
    4:'每日客单价趋势环比上月'
}

export const daily_chart_legend = {
    0:['本月现金收入', '上月同期现金收入'],
    1:['本月用户数', '上月同期用户数'],
    2:['本月新用户数', '上月同期新用户数'],
    3:['本月老用户数', '上月同期老用户数'],
    4:['本月客单价', '上月同期客单价']
}

export const acc_chart_legend = {
    0:['本月MTD现金收入', '上月同期MTD现金收入'],
    1:['本月MTD用户数', '上月同期MTD用户数'],
    2:['本月MTD新用户数', '上月同期MTD新用户数'],
    3:['本月MTD老用户数', '上月同期MTD老用户数'],
    4:['本月客单价', '上月同期客单价']
}